// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* spinner overlay */
#em-loading-overlay {
    font-family: Arial, Helvetica, sans-serif;
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.6);
    z-index: 9999;
    pointer-events: auto;
}

/* hidden state */
#em-loading-overlay.is-hidden {
    display: none;
}

/* center spinner */
.em-loading-spinner {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 4px solid rgba(0, 0, 0, 0.12);
    border-top-color: rgba(0, 0, 0, 0.65);
    animation: em-spinner-rotate 1s linear infinite;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

/* label */
#em-loading-overlay .em-loading-label {
    margin-top: 8px;
    font-size: 13px;
    color: #222;
    text-align: center;
    font-weight: 500;
}

#em-loading-overlay .em-spinner-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
}

@keyframes em-spinner-rotate {
    to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/css/spinner.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,yCAAyC;IACzC,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;IACb,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,qCAAqC;IACrC,+CAA+C;IAC/C,yCAAyC;AAC7C;;AAEA,UAAU;AACV;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC","sourcesContent":["/* spinner overlay */\r\n#em-loading-overlay {\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    position: absolute;\r\n    inset: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(255, 255, 255, 0.6);\r\n    z-index: 9999;\r\n    pointer-events: auto;\r\n}\r\n\r\n/* hidden state */\r\n#em-loading-overlay.is-hidden {\r\n    display: none;\r\n}\r\n\r\n/* center spinner */\r\n.em-loading-spinner {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 50%;\r\n    border: 4px solid rgba(0, 0, 0, 0.12);\r\n    border-top-color: rgba(0, 0, 0, 0.65);\r\n    animation: em-spinner-rotate 1s linear infinite;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* label */\r\n#em-loading-overlay .em-loading-label {\r\n    margin-top: 8px;\r\n    font-size: 13px;\r\n    color: #222;\r\n    text-align: center;\r\n    font-weight: 500;\r\n}\r\n\r\n#em-loading-overlay .em-spinner-stack {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n@keyframes em-spinner-rotate {\r\n    to { transform: rotate(360deg); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
